const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20luxury%20lifestyle%20composition%20with%20golden%20accents%20and%20dark%20elegant%20background%2C%20dramatic%20warm%20lighting%2C%20editorial%20magazine%20style%2C%20sophisticated%20minimal%20aesthetic%2C%20rich%20amber%20and%20deep%20coral%20tones&width=800&height=560&seq=card-news-01&orientation=landscape',
    tag: '独家',
    tagClass: 'bg-accent-500 text-background-50',
    title: '某女星与富豪男友分手内幕，分手费高达千万',
    desc: '据知情人士透露，两人早在半年前就已感情破裂，分手协议涉及多套房产和数千万现金。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=City%20skyline%20with%20real%20estate%20concept%20abstract%20composition%2C%20warm%20amber%20and%20gold%20highlights%20on%20dark%20background%2C%20geometric%20building%20shapes%2C%20urban%20development%20theme%2C%20editorial%20photography%20style&width=800&height=560&seq=card-news-02&orientation=landscape',
    tag: '揭秘',
    tagClass: 'bg-primary-500 text-background-50',
    title: '某省会城市楼市暴跌真相调查',
    desc: '曾经的房价高地如今门可罗雀，记者实地走访发现了背后不为人知的三大原因。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20abstract%20concept%20with%20microphone%20and%20digital%20elements%2C%20warm%20golden%20and%20deep%20rose%20color%20scheme%20on%20dark%20background%2C%20modern%20entertainment%20industry%20aesthetic%2C%20dramatic%20lighting&width=800&height=560&seq=card-news-03&orientation=landscape',
    tag: '独家',
    tagClass: 'bg-accent-500 text-background-50',
    title: '某顶流主播跳槽事件全记录，违约金创行业新高',
    desc: '直播圈年度最大跳槽案，双方博弈长达三个月，最终违约金数字令人咋舌。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Restaurant%20kitchen%20abstract%20composition%20with%20warm%20amber%20lighting%20and%20dark%20moody%20background%2C%20food%20safety%20concept%2C%20investigative%20journalism%20aesthetic%2C%20dramatic%20shadows%2C%20editorial%20photography&width=800&height=560&seq=card-news-04&orientation=landscape',
    tag: '调查',
    tagClass: 'bg-secondary-500 text-background-50',
    title: '深扒某网红餐厅后厨卫生状况令人震惊',
    desc: '表面光鲜的网红打卡地背后，后厨却是另一番景象，食品安全问题触目惊心。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=TV%20studio%20abstract%20composition%20with%20microphone%20and%20spotlight%2C%20warm%20golden%20accents%20on%20dark%20background%2C%20media%20scandal%20concept%2C%20dramatic%20editorial%20style%2C%20sophisticated%20newsroom%20aesthetic&width=800&height=560&seq=card-news-05&orientation=landscape',
    tag: '独家',
    tagClass: 'bg-accent-500 text-background-50',
    title: '某知名主持人被曝学历造假，本人终于回应',
    desc: '持续发酵两周的学历争议迎来当事人首次正面回应，声明全文与细节还原。',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3 tracking-tight">
          图文资讯
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          独家内容 · 深度报道
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card, i) => (
            <a
              key={i}
              href="#"
              onClick={(e) => e.preventDefault()}
              className={`group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300 cursor-pointer ${
                i < 2 ? 'lg:col-span-1' : ''
              }`}
            >
              <div className="relative h-44 md:h-52 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className={`absolute top-3 left-3 text-[10px] font-bold px-2 py-0.5 rounded whitespace-nowrap ${card.tagClass}`}>
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
                <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/70">
                  <span className="text-foreground-400 text-[11px]">
                    <i className="ri-eye-line mr-1"></i>{(Math.random() * 10 + 1).toFixed(1)}万
                  </span>
                  <span className="text-foreground-400 text-[11px]">
                    <i className="ri-chat-1-line mr-1"></i>{Math.floor(Math.random() * 500 + 50)}
                  </span>
                  <span className="text-foreground-400 text-[11px] ml-auto">
                    {Math.floor(Math.random() * 24 + 1)}小时前
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}